import { z } from 'zod';

export const invoicePaymentsStatusResponseSchema = z.object({
    overDueInvoicesCount: z.number(),
});
export type TInvoicePaymentsStatusResponse = z.infer<typeof invoicePaymentsStatusResponseSchema>;
